var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDanger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M4.59271 22.2143H20.4004C22.1465 22.2143 23.2354 20.9612 23.2354 19.3794C23.2354 18.9069 23.1121 18.4241 22.8552 17.9825L14.936 4.18799C14.4019 3.2533 13.4569 2.75 12.5017 2.75C11.5362 2.75 10.5912 3.2533 10.0571 4.18799L2.13786 17.9927C1.88107 18.4344 1.75781 18.9069 1.75781 19.3794C1.75781 20.9612 2.84657 22.2143 4.59271 22.2143Z",
    fill: "url(#paint0_linear_8192_206659)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2806 14.4698C13.2704 15.0039 12.993 15.2915 12.5 15.2915C11.9864 15.2915 11.6988 14.9936 11.6885 14.4698L11.555 9.04646C11.5447 8.52263 11.9351 8.14258 12.4897 8.14258C13.0341 8.14258 13.445 8.5329 13.4347 9.05673L13.2806 14.4698ZM13.6092 17.5613C13.6092 18.1571 13.0854 18.6296 12.4999 18.6296C11.9042 18.6296 11.3906 18.1468 11.3906 17.5613C11.3906 16.9656 11.8939 16.4931 12.4999 16.4931C13.0957 16.4931 13.6092 16.9553 13.6092 17.5613Z",
    fill: "url(#paint1_linear_8192_206659)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8192_206659",
    x1: 1.75781,
    y1: 2.75,
    x2: 1.75781,
    y2: 22.2143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA2D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D01400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8192_206659",
    x1: 11.3906,
    y1: 8.14258,
    x2: 11.3906,
    y2: 18.6295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA2D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D01400"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDanger);
export default __webpack_public_path__ + "static/media/ic_danger.010484c9872e0fb2ddd59dd1dcfa9e0f.svg";
export { ForwardRef as ReactComponent };